import { render, staticRenderFns } from "./CustomerHome.vue?vue&type=template&id=4a9a0e16&"
import script from "./CustomerHome.vue?vue&type=script&lang=js&"
export * from "./CustomerHome.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol})
